export default {
  async paglierani_init(_vm) {

  },
  paglierani_canAddProject(_vm) {
    return true;
  },
  paglierani_canEditProject(_vm, project) {
    return true;
  },
  // Manager o staff assegnato al task
  paglierani_canEditTask(_vm, task) {
    const myJobs = _vm.$store.getters['employments/getAll']
      .reduce(
        (result, employment) => result.concat(employment.jobs) , []
      );
    const accessViaJob = task.jobs.filter(j => myJobs.includes(j)).length > 0;
    return _vm.userPermission < 4 || task.users.includes(_vm.user.idWorldUser) || accessViaJob;
  },
  // Manager
  paglierani_canDeleteTask(_vm, task) {
    return _vm.userPermission < 4;
  }
}